module.exports = __webpack_public_path__ + "static/media/thumbnail.725829d4.jpg";